/* eslint-disable */
import {extendDecorator} from '@/js/common/Domain/Service/mixins/decorators';

@extendDecorator({
    defaults: {
        service: '',
        location: '',
        isReviewSent: false,
        meals: '',
    },
    computeds: {
        ratingText: {
            deps: ['service', 'location', 'meals'],
            get(service, location, meals) {
                let result = '—';
                if (service && location && meals) {
                    result = ((service + location + meals) / 3).toFixed(1);
                }
                return result;
            },
        },
        ratingClass: {
            deps: ['ratingText'],
            get(ratingText) {
                let result;
                const ratingTextFormated = (ratingText === '—') ? 0 : (+ratingText).toFixed();
                switch (+ratingTextFormated) {
                    case 1:
                    case 2:
                        result = 1;
                        break;
                    case 3:
                    case 4:
                        result = 2;
                        break;
                    case 5:
                        result = 3;
                        break;
                    default:
                        result = 0;
                }
                return `leaveCommentForm__total r${result}`;
            },
        },
    },
})
export default class ReviewFormModel extends Backbone.Epoxy.Model {
}